module.exports = __webpack_public_path__ + "static/media/12.9b42d809.jpg";